import { createAuth0 } from '@auth0/auth0-vue'
import axios, { type AxiosInstance } from 'axios'

export const Auth0 = createAuth0(
  {
    domain: import.meta.env.VITE_VUE_APP_AUTH0_DOMAIN,
    clientId: import.meta.env.VITE_VUE_APP_AUTH0_CLIENT_ID,
    // useRefreshTokens: true,
    // cacheLocation: 'localstorage',
    authorizationParams: {
      redirect_uri: `${window.location.origin}/callback`,
      audience: import.meta.env.VITE_VUE_APP_AUTH0_AUDIENCE,
      scope: 'openid profile email user_metadata offline_access'
    }
  },
  { errorPath: '/error' }
)

export const createAxiosAuthInstance =
  (accessToken: string, actorID: string) => (instance?: AxiosInstance) => {
    instance = instance || axios.create()
    instance.interceptors.request.use(async (config) => {
      Object.assign(config.headers, {
        Authorization: `Bearer ${accessToken}`,
        'X-Axuall-Actor': actorID
      })
      return config
    })
    instance.interceptors.response.use(
      (response) => {
        return response
      },
      async function (error) {
        const originalRequest = error.config
        const recoverableAuthErrors = [403]
        if (recoverableAuthErrors.includes(error.response.status) && !originalRequest._retry) {
          originalRequest._retry = true
          const access_token = await Auth0.getAccessTokenSilently()
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token
          // @ts-ignore
          return instance(originalRequest)
        }
        return Promise.reject(error)
      }
    )
    instance.interceptors.response.use()
    return instance
  }

export const createXSRFInstance = (instance?: AxiosInstance) => {
  instance = instance || axios.create()
  instance.interceptors.request.use(async (config) => {
    const regex = /\b_xsrf=(?<token>[^;]*)\b/g
    const matched_regex = regex.exec(document.cookie)
    const xsrf = matched_regex?.groups ? matched_regex.groups['token'] : undefined
    const verbs = new Set(['post', 'put', 'patch', 'delete'])
    if (!config.method || !xsrf) {
      return config
    }
    if (!verbs.has(config.method)) {
      return config
    }
    config.headers['X-XSRFToken'] = xsrf
    return config
  })
  return instance
}
